import React, { useEffect } from 'react'
import { CircularProgress } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useQuery } from 'src/Hooks/useQuery'
import { EHA_ERROR_LOGIN, INSTALLATION_ID, REAUTHENTICATE_LOCAL_STORAGE_KEY, VENDOR_ACCOUNT_ID } from '../../consts'
import { applyReauthenticateVehicle } from '../../api'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'

/*
 * This component redirects you back to the vehicle integration.
 * The backend can only return a static url. the vehicle integration is behind a dynamic url which includes the installation id.
 * Therefore we need a component which redirects you to tis "dynamic" url
 */
const RedirectPage = (): JSX.Element => {
  const query = useQuery()
  const vendorAccountId = query.get(VENDOR_ACCOUNT_ID)
  const error = query.get(EHA_ERROR_LOGIN)
  const installationId = localStorage.getItem(INSTALLATION_ID)
  const vehicleId = localStorage.getItem(REAUTHENTICATE_LOCAL_STORAGE_KEY)
  const navigate = useNavigate()
  const authFetch = useAuthFetchWithResponse()

  const redirectUrl = `/vehicle-integration/${installationId}/vehicle-integration/connect-vehicles?vendorAccount=${vendorAccountId}`
  const redirectManufacturerListUrl = `/vehicle-integration/${installationId}/vehicle-integration/add-vehicle`
  const redirectVehicleListUrl = `/vehicle-integration/${installationId}/vehicle-integration`

  useEffect(() => {
    /* reauthenticate user vehicle */
    if (vendorAccountId && vehicleId && installationId) {
      const applyReauthentication = async (): Promise<void> => {
        await applyReauthenticateVehicle(vehicleId, installationId, vendorAccountId, authFetch)
        navigate(redirectVehicleListUrl)
      }

      applyReauthentication()
      return
    }

    /* connect user vehicle */
    if (vendorAccountId) {
      navigate(redirectUrl)
    }

    if (error) {
      navigate(redirectManufacturerListUrl)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, installationId, redirectUrl, vendorAccountId, error, redirectManufacturerListUrl, vehicleId, redirectVehicleListUrl])

  return <CircularProgress color="primary" />
}

export default RedirectPage
